import { render, staticRenderFns } from "./MateReturn.vue?vue&type=template&id=7706a048&scoped=true"
import script from "./MateReturn.vue?vue&type=script&lang=js"
export * from "./MateReturn.vue?vue&type=script&lang=js"
import style0 from "./MateReturn.vue?vue&type=style&index=0&id=7706a048&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7706a048",
  null
  
)

export default component.exports